import { render, staticRenderFns } from "./TextEmbedding.vue?vue&type=template&id=3259fdd4&lang=pug&"
import script from "./TextEmbedding.vue?vue&type=script&lang=js&"
export * from "./TextEmbedding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports